import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ui-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  /**
   * * Título do Modal.
   */
  @Input() title!: string;
  /**
   * * Mensagem principal do modal (pergunta).
   */
  @Input() mainText!: string;

  /**
   * * Renderiza (ou não) o botão de Confirmação.
   */
  @Input() renderBtnOK: 'true' | 'false' = 'true';
  /**
   * * Renderiza (ou não) o botão de Cancelar.
   */
  @Input() renderBtnCancel: 'true' | 'false' = 'true';

  /**
   * * Texto do botão de Confirmação.
   */
  @Input() okText: string = 'Concordo';
  /**
   * * Texto do botão de Cancelar.
   */
  @Input() cancelText: string = 'Discordo';

  @Input()
  okId!: string;
  @Input()
  cancelId!: string;

  /**
   * * Evento a ser chamado pelo botão de Confirmação.
   */
  @Output() okEvent = new EventEmitter<any>();


  constructor(
    private activeModal: NgbActiveModal
  ) { }

  onInit() {
  }

  public callBtnEvent(event: any) {
    this.okEvent.emit(event);
  }

  close(accept: boolean) {
    this.activeModal.close(accept);
  }

}
